// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__tiS3X","rotate":"loader_rotate__gIIx9"};